// Chakra imports
import { Flex, Heading, useColorModeValue, Text, VStack } from '@chakra-ui/react';

// Custom components
import { HorizonLogo } from 'components/icons/Icons';
import { HSeparator } from 'components/separator/Separator';

export function SidebarBrand() {
	//   Chakra color mode
	let logoColor = useColorModeValue('navy.700', 'white');

	return (
		<Flex alignItems='center' flexDirection='column'>
			<VStack spacing={3}  my='32px'>
			<Heading h='26px' w='auto' color={logoColor} >Tunisie Télécom</Heading>
			<Text color={logoColor}> e-Learning</Text>
			</VStack>
			<HSeparator mb='20px' />
		</Flex>
	);
}

export default SidebarBrand;
